"use client";

import DreamnOddsTrendArrow from "./DreamnOddsTrendArrow";
import { colorOddsChanges } from "@/utils/matchInfo";
import { normalizeDreamnOddsTrend } from "@/utils/dreamnOddsDisplayToggle";

const ODDS_CELL_DIM =
  "kbv-dreamn-odd-cell box-border w-[2.25rem] min-w-[2.25rem] max-w-[2.25rem] shrink-0 sm:w-[2.5rem] sm:min-w-[2.5rem] sm:max-w-[2.5rem] md:w-16 md:min-w-16 md:max-w-16";

const DREAMN_ODD_ALIGN = {
  start: { text: "text-left", justify: "justify-start" },
  center: { text: "text-center", justify: "justify-center" },
  end: { text: "text-right", justify: "justify-end" },
};

export default function DreamnOddValue({ value, trend, textClassName, align = "end" }) {
  const normalized = normalizeDreamnOddsTrend(trend);
  const hasMove = normalized === "increased" || normalized === "decreased";

  const { text: textAlign, justify: justifyClass } =
    DREAMN_ODD_ALIGN[align] ?? DREAMN_ODD_ALIGN.end;

  if (!hasMove) {
    return (
      <div
        className={`op ${ODDS_CELL_DIM} text-[10px] font-bold tabular-nums sm:text-xs md:text-sm ${textAlign} ${textClassName}`}
      >
        {value || "-"}
      </div>
    );
  }

  return (
    <div
      className={`op ${ODDS_CELL_DIM} flex min-h-[1.125rem] flex-row flex-nowrap items-center ${justifyClass}`}
    >
      <span
        className={`inline-flex max-w-full flex-nowrap items-center gap-0.5 text-[10px] font-bold leading-none tabular-nums sm:text-xs md:text-sm ${textAlign} ${colorOddsChanges(normalized)}`}
      >
        <span className="whitespace-nowrap">{value || "-"}</span>
        <DreamnOddsTrendArrow key={`${String(trend)}-${String(value)}`} trend={trend} />
      </span>
    </div>
  );
}
